var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mk-radio',_vm._g({staticClass:"table-radio",attrs:{"label":_vm.scope.row._id},model:{value:(_vm.radioCheckedValue),callback:function ($$v) {_vm.radioCheckedValue=$$v},expression:"radioCheckedValue"}},_vm.$listeners),[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }